var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramPlayTabT(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 60,
    viewBox: "0 0 118 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8109 0L45 2.74117L56.5105 14L45 25.2521L47.8109 28L62.1256 14L47.8109 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6786 0L55.8745 2.74117L67.385 14L55.8745 25.2521L58.6786 28L73 14L58.6786 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8217 37.3789H17.2244V58.6158H20.8217V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6256 37.3789H27.0284V58.6158H30.6256V37.3789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6036 45.6131L18.444 49.0576L19.6057 52.4406L29.7652 48.996L28.6036 45.6131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1361 37.4072H0.5V40.9817H13.1361V37.4072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61954 39.1943H5.02228V58.5929H8.61954V39.1943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6108 60L33.1152 47.2681L41.0291 36L43.9755 38.0426L37.5404 47.2057L45.5 57.8723L42.6108 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0554 45.4521H35.3306V49.0266H44.0554V45.4521Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6262 59.1354L92.9376 43.2256L87.567 59.106L84.0042 57.8998L91.1062 36.8947L92.6785 36.8829L94.663 36.8652L102.171 57.8704L98.6262 59.1354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7033 52.6291L93.0925 50.0205L90.4816 52.6291L93.0925 55.2377L95.7033 52.6291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8062 60V36H73.5692V54.5987L80.2943 52.1157L81.6016 55.646L69.8062 60Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.263 59.806H53.5V36.1943L67.7687 44.0845L57.3042 55.0813L57.263 55.0401V59.806ZM57.263 42.5724V49.6682L61.6855 45.02L57.263 42.5724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.184 50.3209L102.177 37.9238L105.563 36.2881L109.862 45.1608L114.102 36.294L117.5 37.9179L111.576 50.3092L108.184 50.3209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.717 48.1143H107.954V59.7112H111.717V48.1143Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 24,
    fill: "white",
    transform: "translate(0.5 36)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 24,
    fill: "white",
    transform: "translate(53.5 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramPlayTabT);
export default __webpack_public_path__ + "static/media/programPlayTabT.47f5cd6a4abf792d3cff8290129c9c33.svg";
export { ForwardRef as ReactComponent };